<template>
  <div
    :class="{
      scroll: true,
      scrollDeliveryHistory: isDeliveryHistory,
      scrollReservations: isReservations,
      scrollCallbackRequests: isCallbackRequests,
      scrollCustomers: isCustomers,
      scrollAuthenticationHistory: isAuthenticationHistory
    }"
  >
    <table class="table">
      <thead class="thead">
        <tr class="column-main">
          <th
            v-for="column of visibleColumns"
            :key="column.value"
            :class="{
              'column-main-title': true,
              'column-main-title-center': column.value === 'consentGiven'
            }"
          >
            <img
              v-if="
                isCallbackRequests &&
                (column.value === 'Green' || column.value === 'Orange')
              "
              :src="require(`@/assets/icons/${column.value}.svg`)"
              alt=""
            />
            {{ column.label === 'toOrder' ? '' : column.label }}
            <img
              v-if="
                column.value === 'reservedTime' &&
                $route.name === 'APIReservations'
              "
              :class="{
                'img-down': true,
                'img-rotation': changeSort
              }"
              src="@/assets/icons/Down.svg"
              @click="$emit('sortReservedTime')"
            />
          </th>
          <th
            v-if="
              isDeliveryHistory ||
              (isUsers && user?.role.permissions.user.delete) ||
              isReservations
            "
            class="column-main-img"
          ></th>
          <th v-if="isSensorAlarms" class="column-main-img column-main-sensorAlarm">
            <Button
              v-if="selectedAlarms.length"
              class="commentAllSensorAlarm__button"
              variant="filled"
              :title="$t('commentAll')"
              @click="commentAll"
            />
          </th>
        </tr>
      </thead>
      <tbody class="tbody">
        <tr v-for="(i, idx) of data" :key="i.id" class="column-content">
          <td
            v-for="column of visibleColumns"
            :key="column.value"
            :class="{
              'column-content-title': true,
              'column-content-title-width': column.value === 'consentGiven'
            }"
            @click="selectRow(i, column.value)"
          >
            <img
              v-if="
                column.value === 'deliveryIds' &&
                $route.name === 'Reservations' &&
                i.deliveryStatus === 'expired'
              "
              class="img-expired"
              src="@/assets/icons/Red.svg"
            />
            <img
              v-if="column.value === 'deliveryStatus'"
              :src="
                require(`@/assets/icons/${getDeliveryStatus(
                  i[column.value]
                )}.svg`)
              "
              class="status-img"
              alt="status"
            />
            <img
              v-if="column.value === 'status'"
              :src="
                require(`@/assets/icons/${getCallbackRequestsStatus(
                  i[column.value]
                )}.svg`)
              "
              class="status-img"
              alt="status"
            />
            <img
              v-if="column.value === 'pendingRequests'"
              :src="
                require(`@/assets/icons/${getPendingRequests(
                  i[column.value]
                )}.svg`)
              "
              class="status-img"
              alt="status"
            />
            <span
              :class="{
                getColorConfirm: !i.confirmed && column.value === 'content',
                getColorForPending:
                  i.paymentInfo?.status === 'pending' &&
                  column.value === 'paymentInfoStatus',
                getColorForFailed:
                  (i.paymentInfo?.status === 'failed' ||
                    i.paymentInfo?.status === 'cancelled') &&
                  column.value === 'paymentInfoStatus',
                getColorForCompleted:
                  (i.paymentInfo?.status === 'completed' ||
                    i.paymentInfo?.status === 'done') &&
                  column.value === 'paymentInfoStatus',
                getPendingRequests: column.value === 'pendingRequests'
              }"
            >
              {{ getColumnValue(i, column) }}
            </span>
            <p
              v-if="isOrdersHistory && column.value === 'content'"
              class="timestamp"
            >
              {{ dateTime(i.confirmedTime) }}
            </p>

            <div
              v-if="isAuthenticationHistory && i.ssn && column.value === 'ssn'"
              class="column-ssn"
            >
              <span v-if="showSsn[i.timestamp] && i.ssn.length < 20">
                {{ i.ssn }}
              </span>
              <span v-else>**************</span>

              <img
                v-if="showSsn[i.timestamp]"
                class="img-eye"
                src="@/assets/icons/CloseValue.svg"
                alt="Hide"
                @click="hideSsn(i.timestamp)"
              />
              <img
                v-else
                class="img-eye"
                src="@/assets/icons/SeeValue.svg"
                alt="See Value"
                @click="$emit('getSsn', i[selectedField])"
                @click.stop="getSsnOpen(i.timestamp)"
              />
            </div>

            <div
              v-if="
                isOrdersHistory &&
                i.clientInfo.ssn &&
                column.value === 'clientInfoSSN'
              "
              class="column-ssn"
            >
              <span
                v-if="showSsn[i.createdTime] && i.clientInfo.ssn.length < 20"
              >
                {{ i.clientInfo.ssn }}
              </span>
              <span v-else>**************</span>
              <img
                v-if="showSsn[i.createdTime]"
                class="img-eye"
                src="@/assets/icons/CloseValue.svg"
                alt="Hide"
                @click="hideSsn(i.createdTime)"
              />
              <img
                v-else
                class="img-eye"
                src="@/assets/icons/SeeValue.svg"
                alt="See Value"
                @click="$emit('getSsn', i[selectedField])"
                @click.stop="getSsnOpen(i.createdTime)"
              />
            </div>
            <div
              v-if="
                (isAuthenticationHistory || isOrdersHistory) &&
                column.value === 'consentGiven'
              "
              :class="{
                'column-consentGiven': true,
                tootip: isAuthenticationHistory || isOrdersHistory
              }"
            >
              <Checkbox
                name="consentGiven"
                :value="getDataConsentGiven(i.authenticated)"
              />
              <span
                v-if="isAuthenticationHistory || isOrdersHistory"
                :class="{
                  tooltiptext:
                    true && (isAuthenticationHistory || isOrdersHistory),
                  tooltipTextAuthenticationHistory:
                    isAuthenticationHistory || isOrdersHistory,
                  tooltipTextDisplayNone:
                    i.authenticated != 'done' && !isOrdersHistory
                }"
              >
                {{ $t('consentGivenText') }}
              </span>
            </div>
            <div
              v-if="column.value === 'assign'"
              :class="{
                'column-content-img': !isChooseDelivery,
                tootip: isChooseDelivery
              }"
            >
              <img
                class="img"
                src="@/assets/icons/Add.svg"
                alt="Add"
                @click="$emit('assignDeliveryTable', i[selectedField])"
              />
              <span v-if="isChooseDelivery" class="tooltiptext">
                {{ $t('chooseThisDelivery') }}
              </span>
            </div>
            <!-- Display the options in the table on the Customers Feedback page -->
            <div v-if="column.value === 'options'">
              <div
                v-for="(el, index) in i.data"
                :key="index"
                class="column-content-emotion"
              >
                <div v-if="i.data !== 'null' && i.data !== '[]'">
                  <img
                    v-if="showGradeImg(el?.grade)"
                    class="img-emotion"
                    :src="require(`@/assets/icons/${getImg(el.grade)}.png`)"
                    alt="Emotion"
                  />
                  <span v-if="showGradeImg(el?.grade)">-</span>
                  <span v-if="el?.type" class="title-emotion">
                    {{ getFeedbackType(el.type) }}
                  </span>
                </div>
              </div>
            </div>
          </td>
          <td
            v-if="isReservations"
            class="column-content-img"
            @click="$emit('openQrCode', i[selectedField])"
          >
            <img class="img" src="@/assets/icons/Qr-code.svg" alt="Qr-code" />
          </td>
          <td
            v-if="isReservations || isOrdersHistory"
            class="column-content-img"
            :data-testid="'editDescription' + idx"
            @click="$emit('addDescription', i[selectedField], column)"
          >
            <img class="img" src="@/assets/icons/Edit.svg" alt="Edit" />
          </td>
          <td
            v-if="isDeliveryHistory || isAlarms"
            class="column-content-img"
            :data-testid="'editDescriptionDeliveryHistory' + idx"
            @click="selectField(i)"
          >
            <img class="img" src="@/assets/icons/Edit.svg" alt="Edit" />
          </td>
          <td
            v-if="isSensorAlarms"
            class="column-content-img column-content-sensorAlarm"
            :data-testid="'commentSensorAlarm' + idx"
          >
            <div class="sensorAlarm-cell">
              <span
                class="sensorAlarm-checkbox"
                :data-testid="'selectSensorAlarm' + idx"
                @click.stop.prevent="toggleAlarmSelection(i)"
              >
                <Checkbox
                  :name="'sensorAlarmCheck_' + idx"
                  :value="isAlarmSelected(i)"
                />
              </span>
              <Button
                class="commentSensorAlarm__button"
                variant="bordered"
                :title="$t('comment')"
                @click="$emit('commentSensorAlarm', i)"
              />
            </div>
          </td>
          <td
            v-if="isReservations"
            :class="{
              'column-content-img':
                !i.lockerId || i.deliveryStatus === 'delivered',
              'column-content-img-displayNone':
                i.lockerId || i.deliveryStatus !== 'delivered'
            }"
            :data-testid="'resendSMS' + idx"
            @click="$emit('resendSMSRequest', i[selectedField])"
          >
            <img
              class="img imgSMS"
              src="@/assets/icons/SMS.svg"
              alt="Resend SMS"
            />
          </td>
          <td
            v-if="isAPIReservations"
            class="column-content-img"
            @click="$emit('quickReservation', i[selectedField])"
          >
            <Button
              class="quickReservation__button"
              variant="bordered"
              :title="$t('quickReservation')"
            />
          </td>

          <!-- Quick Reservation on the page Orders History -->
          <td
            v-if="
              isOrdersHistory &&
              !i.deliveryId &&
              i.deliveryMethod !== 'homeDelivery'
            "
            class="column-content-img"
            @click="$emit('quickReservation', i[selectedViewOrder])"
          >
            <Button
              class="quickReservation__button"
              variant="bordered"
              :title="$t('quickReservation')"
            />
          </td>
          <td
            v-if="(isReservations && !i.lockerId) || isAPIReservations"
            class="column-content-img"
            :data-testid="'deleteReservation' + idx"
            @click="$emit('deleteReservationTable', i[selectedField])"
          >
            <img
              class="img imgDelete"
              src="@/assets/icons/Delete.svg"
              alt="Delete"
            />
          </td>
          <td
            v-if="isReservations || isAPIReservations"
            :class="{
              'column-content-img':
                (isReservations && !i.lockerId) || isAPIReservations,
              'column-content-img-displayNone': i.lockerId && !isAPIReservations
            }"
            :data-testid="'pickedUpReservation' + idx"
            @click="$emit('pickedUpReservation', i[selectedField])"
          >
            <img
              class="img imgReservation"
              src="@/assets/icons/PickedUpReservation.svg"
              alt="Picked Up Reservation"
            />
          </td>

          <!-- Page Callback Requests-->
          <td
            v-if="isCallbackRequests"
            :class="{
              'column-content-title': true,
              'column-content-title-marks': i.status !== 'done'
            }"
          >
            <!-- Back to Caller Authentication -->
            <div
              v-if="i.status !== 'done'"
              :class="{
                'column-content-img': true,
                tootip: isCallbackRequests
              }"
            >
              <img
                class="img"
                src="@/assets/icons/CallerAuthentication.svg"
                alt="Caller Authentication"
                @click="$emit('openCallerAuthentication', i[selectedField])"
              />
              <span
                :class="{
                  tooltiptext: true,
                  tooltiptextCallbackRequestsLong: isCallbackRequests
                }"
              >
                {{ $t('backToCallerAuthentication') }}
              </span>
            </div>
            <!-- Mark as missed -->
            <div
              v-if="i.status === 'pending'"
              :class="{
                'column-content-img': true,
                tootip: isCallbackRequests
              }"
            >
              <img
                :class="{ img: true, imgMarks: i.status && isCallbackRequests }"
                src="@/assets/icons/MarkAsMissed.svg"
                alt="Mark as Missed"
                @click="$emit('markAsMissed', i[selectedField])"
              />
              <span
                :class="{
                  tooltiptext: true,
                  tooltiptextCallbackRequests: isCallbackRequests
                }"
              >
                {{ $t('markAsMissed') }}
              </span>
            </div>
            <!-- Mark as done -->
            <div
              v-if="i.status !== 'done'"
              :class="{
                'column-content-img': true,
                tootip: isCallbackRequests
              }"
            >
              <img
                :class="{ img: true, imgMarks: i.status && isCallbackRequests }"
                src="@/assets/icons/MarkAsDone.svg"
                alt="Mark as Done"
                @click="$emit('markAsDone', i[selectedField])"
              />
              <span
                :class="{
                  tooltiptext: true,
                  tooltiptextCallbackRequests: isCallbackRequests
                }"
              >
                {{ $t('markAsDone') }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div ref="observer" class="observer"></div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';

import moment from 'moment';

import { PharmacyAccesses, UserProfile } from '@/store/modules/account/types';
import {
  AlarmsData,
  AlarmSensor,
  APIDataReservations,
  Check,
  Contact,
  DataReservations,
  Delivery,
  Grade,
  Sensor
} from '@/store/modules/pharmacy/types';
import { DataLoginInformation } from '@/store/modules/users/types';

import { Column } from '@/types';

import {
  getConsultation,
  getDeliveryMethod,
  getPaymentStatus,
  getContent,
  dateTimeResult,
  getDeliveryLabel,
  getLockerId,
  pickedUpAndDestroyed
} from '@/utils/tableFunctions';

@Options({
  name: 'Table',
  props: [
    'data',
    'columns',
    'selectedField',
    'changeSort',
    'selectedViewOrder'
  ],
  data() {
    return {
      showSsn: {},
      consentGiven: true,
      selectedAlarmKeys: [] as string[]
    };
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy', 'pickupBoxes']),
    ...mapState('entityNames', ['entityNames']),
    isDeliveryHistory() {
      return this.$route.name === 'DeliveryHistory';
    },
    isUsers() {
      return this.$route.name === 'Users';
    },
    isReservations() {
      return this.$route.name === 'Reservations';
    },
    isChooseDelivery() {
      return this.$route.name === 'Lockers';
    },
    isAlarms() {
      return this.$route.name === 'Alarms';
    },
    isSensorAlarms() {
      return (
        this.$route.name === 'SensorAlarms' ||
        this.$route.name === 'SensorGroups' ||
        this.$route.name === 'IndividualSensors'
      );
    },
    isAPIReservations() {
      return this.$route.name === 'APIReservations';
    },
    isAuthenticationHistory() {
      return this.$route.name === 'AuthenticationHistory';
    },
    isOrdersHistory() {
      return this.$route.name === 'OrdersHistory';
    },
    isCallbackRequests() {
      return this.$route.name === 'CallbackRequests';
    },
    isCustomers() {
      return this.$route.name === 'Customers';
    },
    visibleColumns() {
      return this.columns.filter(
        (column: Record<string, string>) => !this.isColumnPharmacyName(column)
      );
    },
    selectedAlarms() {
      if (!this.selectedAlarmKeys.length || !Array.isArray(this.data)) return [];
      return this.data.filter((alarm: AlarmSensor) =>
        this.selectedAlarmKeys.includes(this.alarmKey(alarm))
      );
    }
  },
  methods: {
    // Unique key per alarm row: same sensor can have many alarms, so the start
    // timestamp is combined with the sensor identifier to keep them distinct.
    alarmKey(alarm: AlarmSensor & { sensorSn?: string }) {
      const sensorRef = alarm.sensorSn || alarm.docId || alarm.id || '';
      return `${sensorRef}_${alarm.alarmStartTimestamp}`;
    },
    isAlarmSelected(alarm: AlarmSensor) {
      return this.selectedAlarmKeys.includes(this.alarmKey(alarm));
    },
    toggleAlarmSelection(alarm: AlarmSensor) {
      const key = this.alarmKey(alarm);
      const index = this.selectedAlarmKeys.indexOf(key);
      if (index === -1) {
        this.selectedAlarmKeys.push(key);
      } else {
        this.selectedAlarmKeys.splice(index, 1);
      }
    },
    commentAll() {
      this.$emit('commentSensorAlarmBulk', this.selectedAlarms);
    },
    isColumnPharmacyName(column: Record<string, string>) {
      return this.pickupBoxes.length < 2 && column.value === 'pickupBoxesName';
    },
    getDataConsentGiven(i: string) {
      if (this.isOrdersHistory) {
        return true;
      } else {
        return i === 'done' ? true : false;
      }
    },
    showGradeImg(grade: string | number) {
      if (grade && typeof grade !== 'number') {
        return true;
      }
    },
    selectRow(i: Record<string, unknown>, column: string) {
      if (
        (column === 'deliveryId' || column === 'deliveryIds') &&
        !this.isAPIReservations
      ) {
        this.$emit('openQrCode', i[this.selectedField]);
      } else if (this.isOrdersHistory && column === 'content' && !i.confirmed) {
        this.$emit('openConfirmation', i[this.selectedField]);
      } else if (
        (this.isAPIReservations ||
          this.isReservations ||
          this.isDeliveryHistory ||
          this.isUsers) &&
        column !== 'assign'
      ) {
        this.$emit('goToItem', i[this.selectedField] || i.id, column);
      } else if (this.isOrdersHistory && column !== 'clientInfoSSN') {
        this.$emit('goToItem', i.id);
      }
    },
    selectField(i: Record<string, unknown>) {
      if (this.isAlarms) {
        this.$emit('addAlarmComment', i);
      } else {
        this.$emit('addDescription', i[this.selectedField]);
      }
    },
    getSsnOpen(timestamp: number) {
      this.showSsn[timestamp] = true;
    },
    hideSsn(timestamp: number) {
      this.showSsn[timestamp] = false;
    },
    getUserName(item: Record<string, unknown>) {
      return item.authenticated !== 'done'
        ? ''
        : `${item.firstName} ${item.lastName}`;
    },
    getIds(item: APIDataReservations | DataReservations) {
      if (!item?.additionalDeliveryIds[0] && !item?.additionalDeliveryIds[1]) {
        return item.deliveryId;
      } else if (item?.additionalDeliveryIds[1] !== '') {
        return item.deliveryId + ', ' + item.additionalDeliveryIds.join(', ');
      } else if (item?.additionalDeliveryIds[1] === '') {
        return item.deliveryId + ', ' + item.additionalDeliveryIds.join('');
      }
    },
    dateTime(value: number) {
      if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm');
      }
    },
    getDeliveryStatus(item: string) {
      const colors: Record<string, unknown> = {
        reserved: 'Orange',
        delivered: 'Blue',
        pickup: 'Green',
        expired: 'Gray',
        cancelled: 'Red',
        removed: 'Red',
        deleted: 'Red',
        destroyed: 'Red',
        auto_destroyed: 'Red'
      };

      return colors[item];
    },
    getCallbackRequestsStatus(item: string) {
      const colors: Record<string, unknown> = {
        pending: 'Green',
        missed: 'Orange'
      };

      return colors[item];
    },
    getPendingRequests(item: string) {
      const colors: Record<string, unknown> = {
        pending: 'Green',
        missed: 'Orange'
      };

      return colors[item];
    },
    getRoleLabel(item: string, data: UserProfile) {
      const labels: Record<string, unknown> = {
        main_user: this.$t('mainUser'),
        user: this.$t('user'),
        janitor: this.$t('janitor')
      };

      if (data.pharmacyAccesses) {
        const pharmacyId = localStorage.getItem('id');

        const roleNameForPharmacyId: PharmacyAccesses | undefined =
          data.pharmacyAccesses.find(
            (itemData: PharmacyAccesses) => itemData.pharmacyId === pharmacyId
          );

        return roleNameForPharmacyId
          ? labels[roleNameForPharmacyId?.roleName]
          : '';
      } else {
        return labels[item];
      }
    },
    getDuration(item: AlarmsData | AlarmSensor) {
      let startDate: number | undefined;
      const endDate = item.alarmEndTimestamp;

      if ('alarmStartTimestamp' in item) {
        startDate = item.alarmStartTimestamp;
      } else {
        startDate = item.timestamp;
      }

      if (endDate) {
        const diffTime = Math.abs(endDate - startDate);
        const diffH = Math.ceil(diffTime / (1000 * 60 * 60) - 1);
        const diffMin = Math.ceil(diffTime / (1000 * 60));

        if (!startDate || !endDate) return '';
        if (diffTime === 0) return 0;

        if (diffH === 1) {
          return `${diffH} ${this.$t('hour')}`;
        } else if (diffH === 0) {
          return `${diffMin} ${this.$t('min')}`;
        } else {
          return `${diffH} ${this.$t('hours')}`;
        }
      }
    },
    rounded(averageTemp: number) {
      return +averageTemp.toFixed(2);
    },
    getAverageTemp(item: AlarmsData) {
      let averageTemp;

      if (item.alarmMax && item.alarmMin) {
        averageTemp = (item.alarmMax + item.alarmMin) / 2;
      } else if (item.alarmMax && !item.alarmMin) {
        averageTemp = item.alarmMax / 2;
      } else if (!item.alarmMax && item.alarmMin) {
        averageTemp = item.alarmMin / 2;
      }

      if (!averageTemp) {
        return '';
      }

      this.rounded(averageTemp);

      return `${this.rounded(averageTemp)}`;
    },
    getType(item: string) {
      const type: Record<string, unknown> = {
        fridge: this.$t('fridge'),
        large: this.$t('large'),
        medium: this.$t('medium'),
        small: this.$t('small')
      };

      return type[item];
    },
    getAVG(item: Record<string, unknown>) {
      if (item.averageTime === 1) {
        return `${item.averageTime} ${this.$t('hour')}`;
      } else {
        return `${item.averageTime} ${this.$t('hours')}`;
      }
    },
    getMonth(item: string) {
      const months: Record<string, unknown> = {
        0: this.$t('january'),
        1: this.$t('february'),
        2: this.$t('march'),
        3: this.$t('april'),
        4: this.$t('may'),
        5: this.$t('june'),
        6: this.$t('july'),
        7: this.$t('august'),
        8: this.$t('september'),
        9: this.$t('october'),
        10: this.$t('november'),
        11: this.$t('december')
      };

      return months[item];
    },
    getInfoType(item: DataLoginInformation) {
      const info: Record<string, unknown> = {
        in: this.$t('in'),
        out: this.$t('out')
      };

      return `${this.$t('log')} ${info[item.info]}`;
    },
    getTime(data: Record<string, unknown>, column: Column) {
      if (data[column.value]) {
        return this.dateTime(data[column.value]);
      } else {
        return '';
      }
    },
    getAssignedTime(data: DataReservations) {
      if (data.assignedTime) {
        return this.dateTime(data.assignedTime);
      } else {
        return '';
      }
    },
    getComment(comment: Check) {
      const checkTime = moment(comment.checkTime).format('DD.MM.YYYY HH:mm');
      const checkName = comment.checkName;
      const commentText =
        comment.alarmInfo.length > 30
          ? `${comment.alarmInfo.slice(0, 30)}...`
          : comment.alarmInfo;

      return `${commentText} (${checkName} ${checkTime})`;
    },
    getAlarmComments(data: AlarmsData) {
      if (data.check) {
        // Pickup-box alarms keep the initial alarm record at check[0], so it is
        // skipped. Sensor alarms return only comments in check, so keep them all.
        const comments = this.isSensorAlarms
          ? data.check
          : data.check.slice(1);
        const alarmInfoData = comments.map(this.getComment);

        return alarmInfoData.join('; ');
      }
    },
    getDescriptionText(data: Delivery) {
      const descriptionTextData = data.descriptionText;

      return descriptionTextData?.length > 30
        ? `${descriptionTextData.slice(0, 30)}...`
        : descriptionTextData;
    },
    getAlarmType(data: AlarmsData) {
      const type: Record<string, unknown> = {
        ok: this.$t('alarmOk'),
        door_open: this.$t('alarmDoorOpen'),
        door_closed: this.$t('alarmDoorClosed'),
        temp_high: this.$t('alarmTempHigh'),
        temp_low: this.$t('alarmTempLow'),
        other: this.$t('alarmOther'),
        missing: this.$t('alarmMissing'),
        connection_lost: this.$t('connection_lost')
      };

      return type[data.alarmType];
    },
    getSensor(data: AlarmsData) {
      if (data.alarmType === 'temp_high' || data.alarmType === 'temp_low') {
        if (data.lockerId !== '99-99') {
          return `${this.$t('fridge')} ${data.lockerId}`;
        } else {
          return `${this.$t('roomTemp')}`;
        }
      } else if (data.lockerId) {
        return `${data.lockerId}`;
      }
    },
    getIsDrug(data: APIDataReservations) {
      if (data.is_drug) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    },
    getDeliveryUserName(data: DataReservations) {
      if (data.lockerId) {
        return data.deliveryUserName;
      } else {
        return data.reservedUserName;
      }
    },
    getDeliveryTime(data: DataReservations) {
      if (!data.lockerId) {
        if (data.deliveryTime) {
          return this.dateTime(data.deliveryTime);
        } else {
          return this.dateTime(data.reservedTime);
        }
      }
      return this.dateTime(data.deliveryTime);
    },
    getContact(contact: Record<string, Contact>) {
      return contact?.contact ?? '';
    },
    getGrade(grade: Record<string, Grade>) {
      return grade?.grade ?? '';
    },
    getImg(grade: string) {
      const type: Record<string, unknown> = {
        GOOD: 'HappyPressed',
        OK: 'OkPressed',
        BAD: 'AngryPressed'
      };

      return type[grade];
    },
    getFeedbackType(type: string) {
      return `${type.charAt(0).toUpperCase()}${type
        .slice(1)
        .replace('_', ' ')}`;
    },
    getAuthType(smsAuth: boolean) {
      if (smsAuth === undefined) {
        return '';
      }

      return smsAuth ? `${this.$t('sms')}` : `${this.$t('app')}`;
    },
    getPickupBoxesName(data: DataReservations) {
      const entity = Object.entries(this.entityNames.pickupBoxes).find((item) =>
        item[0].includes(data.pickupboxId)
      );

      const name = entity?.[1] as string;

      return name
        ? name.length > 15
          ? `${name.slice(0, 15)}...`
          : name
        : null;
    },
    getSensorName(data: AlarmSensor) {
      const alarm = data as AlarmSensor & { sensorSn?: string; sn?: string };
      // Group alarms only identify their sensor through the docId, whose prefix
      // is the sensor serial number (e.g. "282C02430DFA-2026-6").
      const snFromDoc = alarm.docId ? alarm.docId.split('-')[0] : undefined;
      return (
        this.pharmacy.sensors.find(
          (sensor: Sensor) =>
            sensor.id === alarm.id ||
            sensor.sn === alarm.sensorSn ||
            sensor.sn === alarm.sn ||
            sensor.sn === snFromDoc
        )?.name || ''
      );
    },
    // eslint-disable-next-line
    getColumnValue(data: any, column: Record<string, string>) {
      switch (column.value) {
        case 'alarmStartTimestamp':
        case 'alarmEndTimestamp':
        case 'timestamp':
        case 'requestedAt':
          return this.dateTime(data[column.value]);
        case 'expiredTime':
        case 'reservedTime':
        case 'pickupTime':
        case 'destroyTime':
          return this.getTime(data, column);
        case 'pickedUpAndDestroyed':
          return pickedUpAndDestroyed(data);
        case 'loginInfoUserName':
        case 'userNAME':
          return this.getUserName(data);
        case 'deliveryStatus':
          return getDeliveryLabel(data[column.value]);
        case 'lockerId':
          return getLockerId(data[column.value]);
        case 'deliveryIds':
          return this.getIds(data);
        case 'duration':
          return this.getDuration(data);
        case 'averageTemp':
          return this.getAverageTemp(data);
        case 'type':
          return this.getType(data[column.value]);
        case 'averageTime':
          return this.getAVG(data);
        case 'month':
          return this.getMonth(data[column.value]);
        case 'infoType':
          return this.getInfoType(data);
        case 'role':
          return this.getRoleLabel(data[column.value], data);
        case 'alarmComment':
          return this.getAlarmComments(data);
        case 'descriptionText':
          return this.getDescriptionText(data);
        case 'alarmType':
          return this.getAlarmType(data);
        case 'sensor':
          return this.getSensor(data);
        case 'is_drug':
          return this.getIsDrug(data);
        case 'deliveryUserName':
          return this.getDeliveryUserName(data);
        case 'deliveryTime':
          return this.getDeliveryTime(data);
        case 'assignedTime':
          return this.getAssignedTime(data);
        case 'clientInfoName':
          return `${data.clientInfo.firstName} ${data.clientInfo.lastName}`;
        case 'clientInfoPhoneNumber':
          return data.clientInfo.phoneNumber;
        case 'consultation':
          return getConsultation(data);
        case 'deliveryMethod':
          return getDeliveryMethod(data.deliveryMethod);
        case 'paymentInfoStatus':
          return getPaymentStatus(data.paymentInfo?.status);
        case 'paymentInfoTotalSum':
          return data.paymentInfo?.totalSum;
        case 'content':
          return getContent(data);
        case 'createdTime':
          return dateTimeResult(data.createdTime);
        case 'paymentInfoIssuedAt':
          return dateTimeResult(data.paymentInfo?.issuedAt);
        case 'contact':
          return this.getContact(data.contact);
        case 'grade':
          return this.getGrade(data.grade);
        case 'smsAuth':
          return this.getAuthType(data.smsAuth);
        case 'pickupBoxesName':
          return this.getPickupBoxesName(data);
        case 'nameSensor':
          return data.nameSensor || this.getSensorName(data);
        case 'clientInfoSSN':
          return '';
        case 'ssn':
          return '';
        case 'status':
          return '';
        default:
          return data[column.value];
      }
    }
  },
  mounted() {
    const options = {
      rootMargin: '0px',
      threshold: 1.0
    };

    const callback = (entries: IntersectionObserverEntry[]) => {
      const lastElement = this.data[this.data.length - 1];
      if (entries[0].isIntersecting && lastElement) {
        this.$emit('loadMore', lastElement.id || lastElement);
      }
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(this.$refs.observer);
  },
  watch: {
    // Clear the alarm selection whenever the underlying rows change (e.g. the
    // list reloads after comments are saved) so stale keys don't linger.
    data() {
      this.selectedAlarmKeys = [];
    }
  }
})
export default class Table extends Vue {}
</script>

<style scoped lang="scss">
.scroll {
  overflow: auto;
  max-height: 944px;
  height: 100%;
  &.scrollDeliveryHistory {
    max-height: 853px;
  }
  &.scrollReservations {
    max-height: 880px;
  }
  &.scrollCallbackRequests {
    max-height: 1029px;
  }
  &.scrollCustomers {
    max-height: 779px;
  }
  &.scrollAuthenticationHistory {
    max-height: 945px;
  }
  .table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    .thead {
      position: sticky;
      top: 0;
      background-color: $white;
      z-index: 2;
      .column-main {
        text-align: left;
        .column-main-title {
          position: sticky;
          top: 0;
          font-family: 'Ubuntu-Medium';
          font-size: $tenSize;
          line-height: $thirteenSize;
          background: $white;
          color: $columnMainTitle;
          padding: 25px 10px 20px 10px;
          letter-spacing: 2px;
          &.column-main-title-center {
            width: 152px;
            text-align: center;
          }
          .img-down {
            cursor: pointer;
          }
          .img-rotation {
            transform: rotate(180deg);
          }
        }
        .column-main-img {
          position: sticky;
          top: 0;
          width: 25px;
          background: $white;
        }
        .column-main-sensorAlarm {
          width: max-content;
          .commentAllSensorAlarm__button {
            width: 140px;
            height: 30px;
          }
        }
      }
    }
    .tbody {
      overflow-y: scroll;
      .column-content {
        border-top: 1px solid $borderTopLine;
        height: 46px;
        &:hover {
          cursor: pointer;
        }
        &:hover .column-content-title,
        &:hover .column-content-title span,
        &:hover .column-content-title p,
        &:hover .column-content-title .column-content-pickedUp,
        &:hover .column-ssn,
        &:hover .column-consentGiven,
        &:hover .img-eye,
        &:hover .column-content-img,
        &:hover .column-content-img .img,
        &:hover .column-content-img-displayNone,
        &:hover .column-content-emotion div,
        &:hover .tootip {
          background-color: $light-grey;
        }
        &:hover .tootip .img {
          opacity: 1;
          visibility: visible;
          background-color: $light-grey;
        }
        &:hover .column-content-img .img {
          height: 18px;
          width: 18px;
          opacity: 1;
          background-color: $light-grey;
        }
        &:hover .column-content-img .imgReservation {
          height: 18px;
          width: 18px;
          opacity: 1;
          filter: invert(58%) sepia(7%) saturate(2247%) hue-rotate(111deg)
            brightness(89%) contrast(99%);
          background-color: rgb(225 82 64 / 0%);
        }
        &:hover .column-content-img .imgDelete {
          height: 18px;
          width: 18px;
          opacity: 1;
          filter: invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg)
            brightness(104%) contrast(97%);
          background-color: rgb(225 82 64 / 0%);
        }
        &:hover .column-content-img .imgSMS {
          height: 18px;
          width: 18px;
          opacity: 1;
        }
        &:hover .column-content-img .quickReservation__button {
          opacity: 1;
        }
        .column-content-title {
          padding: 13px 10px;
          font-size: $fourteenSize;
          line-height: 20px;
          vertical-align: middle;
          color: $columnContentTitle;
          &.column-content-title-marks {
            display: flex;
            justify-content: flex-end;
            .column-content-img {
              width: 28px;
              height: 18px;
              margin-right: 17px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
          &.column-content-title-width {
            text-align: center;
          }
          .column-content-pickedUp {
            display: flex;
            align-items: center;
            .pickedUp-button {
              display: flex;
              align-items: center;
              justify-content: center;
              column-gap: 5px;
            }
          }
          .img-expired {
            padding-right: 5px;
          }
          .getColorConfirm {
            color: $colorCompleted;
          }
          .getColorForPending {
            color: $colorPending;
            background-color: $backgroundPending;
            padding: 6px 8px;
          }
          .getColorForFailed {
            color: $colorFailed;
            background-color: $backgroundFailed;
            padding: 6px 8px;
          }
          .getColorForCompleted {
            color: $colorCompleted;
            background-color: $backgroundCompleted;
            padding: 6px 8px;
          }
          .getPendingRequests {
            display: none;
          }
          .column-ssn {
            display: flex;
            align-items: center;
          }
          .img-eye {
            padding-left: 10px;
            opacity: 0;
          }
          .timestamp {
            color: $servicesTitle;
          }
        }
        &:hover .img-eye {
          opacity: 1;
        }
        &:hover span.getColorForPending {
          background-color: $backgroundPending;
        }
        &:hover span.getColorForFailed {
          background-color: $backgroundFailed;
        }
        &:hover span.getColorForCompleted {
          background-color: $backgroundCompleted;
        }
        .column-content-img {
          vertical-align: middle;
          padding: 5px;
          .img {
            height: 18px;
            width: 18px;
            opacity: 0;
            margin: 0 5px;
            &.imgMarks {
              margin-right: 15px;
            }
          }
          .quickReservation__button {
            width: 150px;
            height: 30px;
            opacity: 0;
          }
          .commentSensorAlarm__button {
            width: 110px;
            height: 30px;
          }
          .sensorAlarm-cell {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
          }
          .sensorAlarm-checkbox {
            display: inline-flex;
            align-items: center;
            cursor: pointer;
          }
        }
        .column-content-img-displayNone {
          display: none;
        }
        .column-content-emotion {
          div {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .img-emotion {
              width: 25px;
              height: 25px;
              margin-right: 4px;
            }
            .title-emotion {
              margin-left: 4px;
            }
          }
        }
        .tootip {
          position: relative;
          display: inline-block;
          .img {
            opacity: 0;
            visibility: hidden;
          }
          .tooltiptext {
            visibility: hidden;
            width: 120px;
            font-size: $elevenSize;
            line-height: $elevenSize;
            background: $label !important;
            color: $white;
            text-align: center;
            border-radius: 6px;
            padding: 5px 0;
            position: absolute;
            z-index: 1;
            top: -35%;
            left: 50%;
            transform: translate(-50%, -100%);
            opacity: 0;
            transition: opacity 0.3s;
            &.tooltiptextCallbackRequests {
              width: 58px;
            }
            &.tooltiptextCallbackRequestsLong {
              width: 90px;
            }
            &.tooltipTextAuthenticationHistory {
              width: 171px;
            }
            &.tooltipTextDisplayNone {
              display: none;
            }
            &::after {
              content: '';
              position: absolute;
              top: 97%;
              left: 50%;
              margin-left: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: $label transparent transparent transparent;
            }
          }
          &:hover .tooltiptext {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
    .observer {
      height: 10px;
      margin-top: 100px;
      background: transparent;
    }
  }
}

.table > :not(:first-child) {
  border-top: none;
}
</style>
